import { Diamond, LockKeyhole, X } from 'lucide-react';
import type { Episode, Series } from '../types';

interface UnlockDialogProps {
  series: Series;
  episode: Episode;
  balance: number;
  onClose: () => void;
  onConfirm: () => void;
  onOpenShop: () => void;
}

export function UnlockDialog({ series, episode, balance, onClose, onConfirm, onOpenShop }: UnlockDialogProps) {
  const affordable = balance >= episode.diamondCost;
  return (
    <div className="modal-backdrop" onMouseDown={onClose}>
      <section className="modal-card unlock-modal" role="dialog" aria-modal="true" aria-label={`Unlock episode ${episode.number}`} onMouseDown={(event) => event.stopPropagation()}>
        <button className="modal-close" onClick={onClose} aria-label="Close unlock dialog"><X /></button>
        <div className="unlock-art"><img src={episode.thumbnail} alt="" /><span><LockKeyhole /></span></div>
        <span className="eyebrow">Locked episode</span>
        <h2>{series.title}</h2>
        <h3>Episode {episode.number}: {episode.title}</h3>
        <p>Unlock this episode permanently for this prototype profile.</p>
        <div className="unlock-balance">
          <span>Your balance</span><strong><Diamond size={16} /> {balance}</strong>
        </div>
        {affordable ? (
          <button className="button button-primary button-full" onClick={onConfirm}>
            <Diamond size={17} /> Unlock for {episode.diamondCost}
          </button>
        ) : (
          <>
            <p className="insufficient-message">You need {episode.diamondCost - balance} more diamonds.</p>
            <button className="button button-primary button-full" onClick={onOpenShop}>Open diamond shop</button>
          </>
        )}
        <button className="button button-ghost button-full" onClick={onClose}>Not now</button>
      </section>
    </div>
  );
}
